import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useLLMPermissions } from "@/hooks/useLLMPermissions";
import { useTranslation } from "@/hooks/useTranslation";
import { useVisibleLLMGroups } from "@/hooks/useVisibleLLMGroups";
import { LLMModelCard } from "./llm-permissions/llm-model-card";

export function TeamSettingLLMPermissions() {
  const { t } = useTranslation();
  const { updateAvailability, setAsDefault } = useLLMPermissions();
  const visibleProviders = useVisibleLLMGroups();
  const visibleModels = visibleProviders.flatMap((provider) => provider.models);

  return (
    <Card>
      {/* Card Header */}
      <CardHeader className="flex flex-row items-start justify-between">
        <div>
          <CardTitle>{t("team.components.llmPermissions.title")}</CardTitle>
          <CardDescription>
            {t("team.components.llmPermissions.description")}
          </CardDescription>
        </div>
      </CardHeader>

      {/* Card Content */}
      <CardContent>
        {visibleModels.length === 0 ? (
          <div className="py-8 text-sm text-center text-muted-foreground">
            {t("team.components.llmPermissions.empty")}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {visibleModels.map((model) => (
              <LLMModelCard
                key={model.id}
                llm={model}
                providerId={model.groupId}
                onUpdateAvailability={updateAvailability}
                onSetAsDefault={setAsDefault}
              />
            ))}
          </div>
        )}
      </CardContent>

      {/* Card Footer */}
      <CardFooter className="px-6 py-4 border-t">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground">
            💡 <strong>{t("team.components.llmPermissions.footer.tip")}</strong>{" "}
            {t("team.components.llmPermissions.footer.tipDescription")}
          </p>
        </div>
      </CardFooter>
    </Card>
  );
}
